import { Box, Dialog, IconButton, List, ListItem, ListItemButton, ListItemText } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { blobSAS } from '../Helper/BlobHelper'
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import ReactPlayer from 'react-player'


const VideoList = (props) => {

    const [url, setUrl] = useState(null);
    const [videoDialog, setVideoDialog] = useState(false);
    const playerRef = useRef(null);
    const [sasToken, setSasToken] = useState(null);

    const handleVideoDialog = () => {
        setVideoDialog(false)
    }

    const handleReady = () => {
        // This ensures metadata is loaded before attempting PiP
        if (playerRef.current && playerRef.current.getInternalPlayer()) {
          playerRef.current.getInternalPlayer().requestPictureInPicture().catch(error => {
            console.error("Failed to request Picture-in-Picture:", error);
          });
        }
      };

    useEffect(() => {
        let isMounted = true;

        const loadSasToken = async () => {
            const tokenData = await blobSAS({ token_type: 'read_only', container_name: 'project-executables' });
            if (isMounted) {
                setSasToken(tokenData);
            }
        };

        loadSasToken();

        return () => {
            isMounted = false;
        };
    }, []);

    return (
        <div>
            <div>
                <List dense={true}>
                    {props.videos.map((data, index) => {
                        return (
                            <ListItemButton onClick={() => { setVideoDialog(true); setUrl(data.asset_source);}}>
                                <ListItem>
                                    <ListItemText
                                        primary={data.name}
                                        secondary={data.description ? data.description : null}
                                    />
                                </ListItem>
                            </ListItemButton>
                        )
                    })}
                </List>
            </div>
            <Dialog fullWidth={true} maxWidth="md" open={videoDialog} onClose={handleVideoDialog}>
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Box sx={{ m: 2 }}>
                        <ReactPlayer
                            url={sasToken ? sasToken.fd_account_url + url + "?" + sasToken.read_only?.['project-executables'].sas_token : ''}
                            controls={true} pip={true} stopOnUnmount={false}
                            width="500" height="500"
                            onReady={handleReady}
                            playing
                            playIcon={<IconButton><PlayArrowIcon color="primary" sx={{ fontSize: 120 }} /></IconButton>}
                            config={{
                                file: {
                                    attributes: {
                                        controlsList: 'nodownload',
                                        onContextMenu: e => e.preventDefault()
                                    }
                                }
                            }}
                        />
                    </Box>
                </Box>
            </Dialog>
        </div>
    )
}

export default VideoList